import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { tickDouble } from "../../../../../../icon/tickDouble";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { CourseDataInfo } from "../../../../../../types";

interface LearningObjectivesProps {
  learningObjectives: CourseDataInfo;
}

export const CourseLearningObjectivesPreview = ({
  learningObjectives,
}: LearningObjectivesProps) => {
  const [showAll, setShowAll] = React.useState(false);
  const filteredObjectives =
    learningObjectives?.objectives?.filter((obj) => obj) || [];
  const displayLimit = 4;
  const handleToggleShowAll = () => {
    setShowAll(!showAll);
  };
  if (filteredObjectives?.length === 0) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: "20px" }}>
      <Typography
        sx={{
          marginTop: "64px",
          fontSize: "24px",
          fontWeight: 800,
        }}
        variant="h6"
        gutterBottom>
        Чему вы научитесь:
      </Typography>
      <List>
        {learningObjectives?.objectives
          .slice(
            0,
            showAll ? learningObjectives?.objectives.length : displayLimit
          )
          .map((objective: any, index: any) => (
            <ListItem
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
              }}>
              {tickDouble}
              <ListItemText
                primary={objective}
                sx={{
                  fontSize: "18px",
                  fontWeight: 400,
                  color: "#000",
                  paddingLeft: "8px",
                }}
              />
            </ListItem>
          ))}
      </List>
      {filteredObjectives && filteredObjectives.length > displayLimit && (
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: 800,
            color: "#0573E4",
            textTransform: "none",
          }}
          onClick={handleToggleShowAll}>
          {showAll ? (
            <>
              <span>Скрыть</span>
              <ExpandLessIcon />
            </>
          ) : (
            <>
              <span>Показать все</span>
              <ExpandMoreIcon />
            </>
          )}
        </Button>
      )}
    </Box>
  );
};
